// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sigPad {
  width: 100%;
  height: 100%;
  border: 1px solid #87939a;
}

.agreement .buttons {
  width: 100%;
  height: 30px;
}

.agreement input[type="text"]  {
  border: 0px !important;
  border-bottom: 2px solid black !important;
  border-radius: 0px !important;
}
.agreement input[type="email"]  {
    border: 0px !important;
    border-bottom: 2px solid black !important;
    border-radius: 0px !important;
}
  .agreement input[type="tel"]  {
    border: 0px !important;
    border-bottom: 2px solid black !important;
    border-radius: 0px !important;
  }
  .agreement input[type="date"]  {
    border: 0px !important;
    border-bottom: 2px solid black !important;
    border-radius: 0px !important;
  }

.agreement input:focus {
  box-shadow: none !important;
}

.font-weight-bold {
  font-size: 15px;
  font-weight: 700;
}
.agreement h1,.agreement h2,.agreement h3,.agreement h4 ,.agreement h5,.agreement h6  {
    color: #00aeef !important;
    margin: 15px 0;
  }
  

/* @media (max-width: 900px) {
    input{
        width: 100% !important;
    }
} */

/* 3d style */




        .other1 {
            border: none;
            border-bottom: 1px solid #000;
            border-radius: 0px;
            background: transparent;
        }

        .gernal-info p {
            margin: 0;
        }

        .header h2 {
            background-color: #00AEEF;
            padding: 1rem;
            color: #fff;
        }

        .help-block {
            color: red;
        }

        .questions p {
            margin: 0;
        }

        .skine-care p {
            margin: 0;
        }

        .sec-1 {
            background-color: #f6f6f6;
            padding: 1rem;
        }

        @media (max-width: 576px) {
            .right {
                text-align: left;
            }
        }

        @media (max-width:576px) {
            .style1 {
                margin-left: 4rem;
                margin-top: 2rem;
            }

            .btn-1 {
                padding-left: 16px;
                padding-right: 14px;
                border-radius: 20px;
                padding-top: 11px;
                padding-bottom: 14px;

            }

            .p-5 {
                padding: 1rem !important;
            }

        }

        @media (min-width:768px) {
            .style2 {
                margin-left: 7rem;
                margin-top: 3rem;
            }

            .btn-lg {
                padding-left: 56px;
                padding-right: 56px;
                border-radius: 20px;
                padding-top: 10px;
                padding-bottom: 12px;
            }
        }

        @media (min-width:1024px) {
            .style3 {
                margin-left: 16rem;
                margin-top: 4rem;
            }
        }

        @media (min-width:1440px) {
            .style4 {
                margin-left: 21rem;
                margin-top: 4rem;
            }
        }

        @media (max-width:576px) {
            .text-justify {
                font-size: 16px
            }

            .sec-1 h5 {
                font-size: 16px
            }

            .header h2 {
                font-size: 16px;
            }

            .gernal-info h3 {
                font-size: 18px;
            }

            .medical-history h2 {
                font-size: 21px;
            }

            .skine-care h2 {
                font-size: 21px;
            }

            .Important-Information h2 {
                font-size: 21px;
            }
        }

        @media screen and (min-width: 200px) and (max-width: 500px) {
            .logoImg .vivImg img {
                    float: none !important;
                }
        }

        .ch-1 {
            appearance: none;
            -webkit-appearance: none;
            height: 40px;
            width: 40px;
            background-color: #d5d5d5;
            border-radius: 5px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 6px;
        }

        .ch-1:after {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            font-size: 30px;
            content: "\\f00c";
            color: white;
            display: none;
        }

        .ch-1:hover {
            background-color: #f6f6f6;
        }

        .ch-1:checked {
            background-color: #00AEEF;
        }

        .by-saying-below {
            background-color: #f6f6f6;
            padding: 2rem;
        }

        .ch-1:checked:after {
            display: block;
        }

        .pics img {
            width: 60%;
        }

        .table-heading-bg-color {
            background: #f6f6f6;
        }

        .table-heading-bg-color th {
            font-size: 20px;
        }

        .selected-brow-shape {
            margin-top: 6rem;
        }

        .selected-brow-shape ul {
            list-style: none;
        }

        .selected-brow-shape h6 {
            margin-left: 1rem;
        }

        .selected-thickness h6 {
            margin-left: 1rem;
        }

        .selected-shade h6 {
            margin-left: 1rem;
        }

        .selected-shade ul {
            list-style: none;
        }

        .male-pic img {
            height: 33rem;
        }
        .logoImg img {
            width: 50%;
        }
        .logoImg .vivImg img {
            float: right;
        }
`, "",{"version":3,"sources":["webpack://./src/pages/user/chart-form/signature.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,6BAA6B;AAC/B;AACA;IACI,sBAAsB;IACtB,yCAAyC;IACzC,6BAA6B;AACjC;EACE;IACE,sBAAsB;IACtB,yCAAyC;IACzC,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,yCAAyC;IACzC,6BAA6B;EAC/B;;AAEF;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;EAChB;;;AAGF;;;;GAIG;;AAEH,aAAa;;;;;QAKL;YACI,YAAY;YACZ,6BAA6B;YAC7B,kBAAkB;YAClB,uBAAuB;QAC3B;;QAEA;YACI,SAAS;QACb;;QAEA;YACI,yBAAyB;YACzB,aAAa;YACb,WAAW;QACf;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,SAAS;QACb;;QAEA;YACI,SAAS;QACb;;QAEA;YACI,yBAAyB;YACzB,aAAa;QACjB;;QAEA;YACI;gBACI,gBAAgB;YACpB;QACJ;;QAEA;YACI;gBACI,iBAAiB;gBACjB,gBAAgB;YACpB;;YAEA;gBACI,kBAAkB;gBAClB,mBAAmB;gBACnB,mBAAmB;gBACnB,iBAAiB;gBACjB,oBAAoB;;YAExB;;YAEA;gBACI,wBAAwB;YAC5B;;QAEJ;;QAEA;YACI;gBACI,iBAAiB;gBACjB,gBAAgB;YACpB;;YAEA;gBACI,kBAAkB;gBAClB,mBAAmB;gBACnB,mBAAmB;gBACnB,iBAAiB;gBACjB,oBAAoB;YACxB;QACJ;;QAEA;YACI;gBACI,kBAAkB;gBAClB,gBAAgB;YACpB;QACJ;;QAEA;YACI;gBACI,kBAAkB;gBAClB,gBAAgB;YACpB;QACJ;;QAEA;YACI;gBACI;YACJ;;YAEA;gBACI;YACJ;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;QACJ;;QAEA;YACI;oBACQ,sBAAsB;gBAC1B;QACR;;QAEA;YACI,gBAAgB;YAChB,wBAAwB;YACxB,YAAY;YACZ,WAAW;YACX,yBAAyB;YACzB,kBAAkB;YAClB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;QACnB;;QAEA;YACI,kCAAkC;YAClC,gBAAgB;YAChB,eAAe;YACf,gBAAgB;YAChB,YAAY;YACZ,aAAa;QACjB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;YACzB,aAAa;QACjB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,iBAAiB;QACrB;;QAEA;YACI,iBAAiB;QACrB;;QAEA;YACI,iBAAiB;QACrB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,aAAa;QACjB;QACA;YACI,UAAU;QACd;QACA;YACI,YAAY;QAChB","sourcesContent":[".sigPad {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #87939a;\n}\n\n.agreement .buttons {\n  width: 100%;\n  height: 30px;\n}\n\n.agreement input[type=\"text\"]  {\n  border: 0px !important;\n  border-bottom: 2px solid black !important;\n  border-radius: 0px !important;\n}\n.agreement input[type=\"email\"]  {\n    border: 0px !important;\n    border-bottom: 2px solid black !important;\n    border-radius: 0px !important;\n}\n  .agreement input[type=\"tel\"]  {\n    border: 0px !important;\n    border-bottom: 2px solid black !important;\n    border-radius: 0px !important;\n  }\n  .agreement input[type=\"date\"]  {\n    border: 0px !important;\n    border-bottom: 2px solid black !important;\n    border-radius: 0px !important;\n  }\n\n.agreement input:focus {\n  box-shadow: none !important;\n}\n\n.font-weight-bold {\n  font-size: 15px;\n  font-weight: 700;\n}\n.agreement h1,.agreement h2,.agreement h3,.agreement h4 ,.agreement h5,.agreement h6  {\n    color: #00aeef !important;\n    margin: 15px 0;\n  }\n  \n\n/* @media (max-width: 900px) {\n    input{\n        width: 100% !important;\n    }\n} */\n\n/* 3d style */\n\n\n\n\n        .other1 {\n            border: none;\n            border-bottom: 1px solid #000;\n            border-radius: 0px;\n            background: transparent;\n        }\n\n        .gernal-info p {\n            margin: 0;\n        }\n\n        .header h2 {\n            background-color: #00AEEF;\n            padding: 1rem;\n            color: #fff;\n        }\n\n        .help-block {\n            color: red;\n        }\n\n        .questions p {\n            margin: 0;\n        }\n\n        .skine-care p {\n            margin: 0;\n        }\n\n        .sec-1 {\n            background-color: #f6f6f6;\n            padding: 1rem;\n        }\n\n        @media (max-width: 576px) {\n            .right {\n                text-align: left;\n            }\n        }\n\n        @media (max-width:576px) {\n            .style1 {\n                margin-left: 4rem;\n                margin-top: 2rem;\n            }\n\n            .btn-1 {\n                padding-left: 16px;\n                padding-right: 14px;\n                border-radius: 20px;\n                padding-top: 11px;\n                padding-bottom: 14px;\n\n            }\n\n            .p-5 {\n                padding: 1rem !important;\n            }\n\n        }\n\n        @media (min-width:768px) {\n            .style2 {\n                margin-left: 7rem;\n                margin-top: 3rem;\n            }\n\n            .btn-lg {\n                padding-left: 56px;\n                padding-right: 56px;\n                border-radius: 20px;\n                padding-top: 10px;\n                padding-bottom: 12px;\n            }\n        }\n\n        @media (min-width:1024px) {\n            .style3 {\n                margin-left: 16rem;\n                margin-top: 4rem;\n            }\n        }\n\n        @media (min-width:1440px) {\n            .style4 {\n                margin-left: 21rem;\n                margin-top: 4rem;\n            }\n        }\n\n        @media (max-width:576px) {\n            .text-justify {\n                font-size: 16px\n            }\n\n            .sec-1 h5 {\n                font-size: 16px\n            }\n\n            .header h2 {\n                font-size: 16px;\n            }\n\n            .gernal-info h3 {\n                font-size: 18px;\n            }\n\n            .medical-history h2 {\n                font-size: 21px;\n            }\n\n            .skine-care h2 {\n                font-size: 21px;\n            }\n\n            .Important-Information h2 {\n                font-size: 21px;\n            }\n        }\n\n        @media screen and (min-width: 200px) and (max-width: 500px) {\n            .logoImg .vivImg img {\n                    float: none !important;\n                }\n        }\n\n        .ch-1 {\n            appearance: none;\n            -webkit-appearance: none;\n            height: 40px;\n            width: 40px;\n            background-color: #d5d5d5;\n            border-radius: 5px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-top: 6px;\n        }\n\n        .ch-1:after {\n            font-family: \"Font Awesome 5 Free\";\n            font-weight: 900;\n            font-size: 30px;\n            content: \"\\f00c\";\n            color: white;\n            display: none;\n        }\n\n        .ch-1:hover {\n            background-color: #f6f6f6;\n        }\n\n        .ch-1:checked {\n            background-color: #00AEEF;\n        }\n\n        .by-saying-below {\n            background-color: #f6f6f6;\n            padding: 2rem;\n        }\n\n        .ch-1:checked:after {\n            display: block;\n        }\n\n        .pics img {\n            width: 60%;\n        }\n\n        .table-heading-bg-color {\n            background: #f6f6f6;\n        }\n\n        .table-heading-bg-color th {\n            font-size: 20px;\n        }\n\n        .selected-brow-shape {\n            margin-top: 6rem;\n        }\n\n        .selected-brow-shape ul {\n            list-style: none;\n        }\n\n        .selected-brow-shape h6 {\n            margin-left: 1rem;\n        }\n\n        .selected-thickness h6 {\n            margin-left: 1rem;\n        }\n\n        .selected-shade h6 {\n            margin-left: 1rem;\n        }\n\n        .selected-shade ul {\n            list-style: none;\n        }\n\n        .male-pic img {\n            height: 33rem;\n        }\n        .logoImg img {\n            width: 50%;\n        }\n        .logoImg .vivImg img {\n            float: right;\n        }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
